import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllFranchises, getAllRepresentatives } from '../../../../actions/inventoryActions'
import { getConsolidateProducts } from '../../../actions/transferActions'
import CreateConsignmentView from '../../../containers/Inventory/Consignment/CreateConsignment/CreateConsignment'

const CreateConsignment = () => {
  const dispatch = useDispatch()
  const { consolidateProducts } = useSelector(state => state.tranfers)
  const { franchises,representatives } = useSelector(state => state.inventory)
  const [string, setString] = useState("")
  const [entity, setEntity] = useState(null)
  useEffect(() => {
    dispatch(getConsolidateProducts(0, ""))
    
    return () => {

    }
  }, [])
  useEffect(() => {
    dispatch(getAllFranchises(string,50, 0))
    dispatch(getAllRepresentatives(string,50, 0))
    return () => {

    }
  }, [string])


  return (
    <CreateConsignmentView products={consolidateProducts}  string={string} setString={setString} franchises={franchises} representatives={representatives} 
    
    entity={entity}
setEntity={setEntity}
    />
  )
}

export default CreateConsignment